module.exports = __webpack_public_path__ + "img/logo_mw_social_white.7f53f031.png";